import { action } from 'easy-peasy';
import { IActionSetAllocationTeamMembers } from '../types';

const setAllocationTeamMembers: IActionSetAllocationTeamMembers = action((state, payload) => {
  state.allocationTeamMembers = payload;
});

export default setAllocationTeamMembers;
